module.exports = __webpack_public_path__ + "img/access_for_the_whole_team.03e85ae7.png";